// =============================================================================
// USERS PAGES LAYOUTS
// =============================================================================

import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'users',
  component: () => import('../../views/admin/users/index.vue'),
  children: [
    {
      path: '',
      name: 'users',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileUsers" */ '@/mobile/views/admin/users/list/usersList.vue') : import(/* webpackChunkName: "desktopUsers" */ '@/desktop/views/admin/users/list/usersList.vue') },
      meta: {
        permission: 'user.show',
        pageTitle: 'اشخاص',
        pageTitleI18n: 'pages.users.users.list.title'
        // rule: 'editor'
      }
    },
    {
      path: 'test',
      name: 'test',
      component: () => { return import(/* webpackChunkName: "desktopUserstest" */ '@/mobile/test.vue') },
      meta: {
        permission: 'user.show',
        pageTitle: 'اشخاص',
        pageTitleI18n: 'pages.users.users.list.title'
        // rule: 'editor'
      }
    },
    {
      path: 'trash',
      name: 'usersTrash',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileUsersTrash" */ '@/mobile/views/admin/users/trash/usersTrash.vue') : import(/* webpackChunkName: "desktopUsersTrash" */ '@/desktop/views/admin/users/list/usersList.vue') },
      meta: {
        permission: 'user.delete',
        pageTitle: 'سطل زباله اشخاص',
        pageTitleI18n: 'pages.users.users.trash.title'
        // rule: 'editor'
      }
    },
    {
      path: 'insert',
      name: 'insertUser',
      component: () => import(/* webpackChunkName: "insertUser" */ '../../views/admin/users/insert/insertUser.vue'),
      meta: {
        permission: 'user.create',
        pageTitle: 'افزودن شخص',
        pageTitleI18n: 'pages.users.users.insert.title'
        // rule: 'editor'
      }
    },
    {
      path: 'roles',
      component: () => import(/* webpackChunkName: "access" */ '../../views/admin/users/access/index.vue'),
      children: [
        {
          path: '',
          name: 'accessGroupsList',
          component: () => import(/* webpackChunkName: "accessGroupsList" */ '../../views/admin/users/access/list/accessGroupsList.vue'),
          meta: {
            permission: 'role.show',
            pageTitle: '',
            pageTitleI18n: 'pages.users.accessGroup.title'
            // rule: 'editor'
          }
        }
      ]
    },
    {
      path: ':id',
      component: () => { return isMobile() ?  import('@/mobile/views/admin/users/user/index.vue') : import('@/desktop/views/admin/users/user/index.vue') },
      meta: {
        redirectNotFound: true
      },
      children: [
        {
          path: '',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileUser" */ '@/mobile/views/admin/users/user/profile/userProfile.vue') : import(/* webpackChunkName: "desktopUser" */ '@/desktop/views/admin/users/user/profile/userProfile.vue') },
          name: 'user',
          meta: {
            permission: 'user.show',
            pageTitle: 'شخص',
            pageTitleI18n: 'pages.users.users.profile.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'edit',
          name: 'editUser',
          component: () => import(/* webpackChunkName: "editUser" */ '../../views/admin/users/edit/editUser.vue'),
          meta: {
            permission: 'user.update',
            pageTitle: ',ویرایش اطلاعات شخص',
            pageTitleI18n: 'pages.users.users.edit.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'transactions',
          name: 'userTransactions',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileUserTransactions" */ '@/mobile/views/admin/users/user/transactions/userTransactions.vue') : import(/* webpackChunkName: "desktopUserTransactions" */ '@/desktop/views/admin/users/user/transactions/userTransactions.vue') },
          meta: {
            permission: 'user.show',
            pageTitle: 'گردش مالی شخص',
            pageTitleI18n: 'pages.users.users.transactions.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'points',
          name: 'userPoints',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileUserPoints" */ '@/mobile/views/admin/users/user/points/userPoints.vue') : import(/* webpackChunkName: "desktopUserPoints" */ '@/desktop/views/admin/users/user/points/userPoints.vue') },
          meta: {
            permission: 'user.show',
            pageTitle: 'امتیاز شخص',
            pageTitleI18n: 'pages.users.users.points.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'max-debt',
          name: 'userMaxDebt',
          component: () => import(/* webpackChunkName: "userTransactions" */ '../../views/admin/users/user/maxDebt/setUserMaxDebt.vue'),
          meta: {
            permission: 'user.show',
            pageTitle: 'گردش مالی شخص',
            pageTitleI18n: 'pages.users.users.profile.setMaxDebtModal.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'message',
          name: 'sendMessageToUser',
          component: () => import(/* webpackChunkName: "sendMessageToUser" */ '../../views/admin/users/user/chat/userChatRoom.vue'),
          meta: {
            permission: 'user.show',
            pageTitle: 'گردش مالی شخص',
            pageTitleI18n: 'components.smsMessageInput.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'transactions/:docId',
          name: 'userTransaction',
          component: () => import(/* webpackChunkName: "userTransaction" */ '../../views/admin/accountancy/documents/document/document.vue'),
          meta: {
            permission: 'user.show',
            pageTitle: 'سند گردش مالی شخص',
            pageTitleI18n: 'pages.users.users.transactions.documentTitle',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'addresses',
          name: 'userAddresses',
          component: () => import(/* webpackChunkName: "userAddresses" */ '../../views/admin/users/user/addresses/userAddresses.vue'),
          meta: {
            permission: 'user.show',
            pageTitle: 'شخص',
            pageTitleI18n: 'pages.users.users.addresses.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'sale',
          name: 'insertUserSaleInvoice',
          component: () => import(/* webpackChunkName: "insertUserSaleInvoice" */ '../../views/admin/sales/invoices/insert/insertSaleInvoice.vue'),
          meta: {
            permission: 'sale_invoice.create',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.invoices.insert.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'purchase',
          name: 'insertUserPurchaseInvoice',
          component: () => import(/* webpackChunkName: "insertUserPurchaseInvoice" */ '../../views/admin/purchases/invoices/insert/insertPurchaseInvoice.vue'),
          meta: {
            permission: 'purchase_invoice.create',
            pageTitle: 'افزودن فاکتور خرید',
            pageTitleI18n: 'pages.purchases.invoices.insert.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'receive',
          name: 'insertUserReceive',
          component: () => import(/* webpackChunkName: "insertUserReceive" */ '../../views/admin/treasury/receive/insert/insertReceive.vue'),
          meta: {
            pageTitle: 'دریافت',
            pageTitleI18n: 'pages.treasury.receive.insert.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'payment',
          name: 'insertUserPayment',
          component: () => import(/* webpackChunkName: "insertUserPayment" */ '../../views/admin/treasury/payment/insert/insertPayment.vue'),
          meta: {
            pageTitle: 'پرداخت جدید',
            pageTitleI18n: 'pages.treasury.payment.insert.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'cost',
          name: 'insertUserCost',
          component: () => import(/* webpackChunkName: "insertUserCost" */ '../../views/admin/accountancy/cost/insert/insertCost.vue'),
          meta: {
            permission: 'cost.create',
            pageTitle: 'هزینه جدید',
            pageTitleI18n: 'pages.treasury.cost.insert.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'activities-log',
          name: 'userActivitiesLog',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileUserActivitiesLog" */ '@/mobile/views/admin/users/user/activitiesLog/userActivitiesLog.vue') : import(/* webpackChunkName: "desktopUserActivitiesLog" */ '@/desktop/views/admin/users/user/activitiesLog/userActivitiesLog.vue') },
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های شخص',
            pageTitleI18n: 'pages.users.users.logs.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        }
      ]
    }
  ]
}
